import React from "react";

import { Button } from "components/ui/Button";

import styles from "./DataTableBulkActions.module.css";

export const DataTableBulkActions = ({
  selectedCount,
  selectedItems,
  bulkActions = [],
  onDeselectAll,
  selection,
}) => {
  if (selectedCount === 0) return null;

  return (
    <div className={styles.bulkActions}>
      <div className={styles.bulkActionsLeft}>
        <span className={styles.bulkCount}>
          {selectedCount} item{selectedCount !== 1 ? "s" : ""} selected
        </span>
        <Button
          variant="text"
          size="small"
          onClick={onDeselectAll}
        >
          Clear
        </Button>
      </div>
      <div className={styles.bulkActionsRight}>
        {bulkActions.map((action, i) => {
          const Icon = action.icon;
          return (
            <Button
              key={i}
              variant="text"
              size="small"
              onClick={() => action.onClick?.(selectedItems, selection)}
            >
              {Icon && <Icon size={16} />}
              {action.label}
            </Button>
          );
        })}
      </div>
    </div>
  );
};
